var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_384",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29241",
    "data-name": "Group 29241",
    transform: "translate(211 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -211, -10837)",
    filter: "url(#Ellipse_384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384-2",
    "data-name": "Ellipse 384",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50277",
    "data-name": "Path 50277",
    d: "M39.534,44.228,36.921,39,33,42.921Z",
    transform: "translate(-202.409 -10832.53)",
    fill: "#0277bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50278",
    "data-name": "Path 50278",
    d: "M31.383,39.014,36.36,39,35.04,44.867H32.33Z",
    transform: "translate(-201.849 -10832.53)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50279",
    "data-name": "Path 50279",
    d: "M20.4,9.949s7.188-1.259,7.188-5.326S22.927-2.522,15.107,3.046c-7.57-2-10.386,5.42-8.385,10.113-2.127,5.005,1.44,9.532,4.756,8.969C11.79,20,20.4,9.949,20.4,9.949Z",
    transform: "translate(-193.08 -10819.022)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50280",
    "data-name": "Path 50280",
    d: "M25.449,33.693l.626,4.8H12.936l1.335-10.511Z",
    transform: "translate(-195.456 -10828.711)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50281",
    "data-name": "Path 50281",
    d: "M13.39,23.023c.646,2.086,2.444,5.916,7.109,6.686,2.315.375,5.77-.133,6.208-1.384A64.974,64.974,0,0,0,28.333,20.5c0-.751-2.315-2.69-1.752-4.255s-.313-3.942-.313-3.942a11.013,11.013,0,0,1-9.885.938,2.761,2.761,0,0,1-2.753,2.5c1.249,1.866.978,3.7-.25,5.506a2.623,2.623,0,0,0-1.251-2.315s-1.439-.5-1.877.625.313,4.066,1.689,4.5S13.256,23.57,13.39,23.023Z",
    transform: "translate(-194.483 -10823.28)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50282",
    "data-name": "Path 50282",
    d: "M21.17,19.787h2.867s1.191-2.25-.6-2.287A2.361,2.361,0,0,0,21.17,19.787Z",
    transform: "translate(-198.31 -10825.079)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50283",
    "data-name": "Path 50283",
    d: "M30.043,19.809a3.387,3.387,0,0,0,1.668,2.836,3.833,3.833,0,0,1-.917,1.46,3.188,3.188,0,0,0,1.96-1.752C31.294,21.936,30.043,19.809,30.043,19.809Z",
    transform: "translate(-201.385 -10825.88)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50284",
    "data-name": "Path 50284",
    d: "M23.021,42.1l4.8.751,1.5-2.127,1.334-.042,1.57,4.769-7.242-.014Z",
    transform: "translate(-198.951 -10833.113)",
    fill: "#ff5722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50285",
    "data-name": "Path 50285",
    d: "M30.419,28.633l.031,1.411.719-.031-.959,2.315.01-1s-4.494,1.168-6.434-1.8C25.476,28.862,30.419,28.633,30.419,28.633Z",
    transform: "translate(-199.217 -10828.938)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50286",
    "data-name": "Path 50286",
    d: "M31.124,27.688l-1.6,1.283-6.476.219A10.14,10.14,0,0,1,31.124,27.688Z",
    transform: "translate(-198.962 -10828.524)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50287",
    "data-name": "Path 50287",
    d: "M30.228,29v1.307S26.307,31.614,25,29.653A21.019,21.019,0,0,1,30.228,29Z",
    transform: "translate(-199.637 -10829.064)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50288",
    "data-name": "Path 50288",
    d: "M22.039,19a.975.975,0,0,0-.51.146,2.826,2.826,0,0,0-.359,1.161h1.789a.969.969,0,0,0,.06-.327A.981.981,0,0,0,22.039,19Z",
    transform: "translate(-198.31 -10825.6)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50289",
    "data-name": "Path 50289",
    d: "M31.17,19.828h2.214s.59-1.889-.26-2.155C31.789,17.256,31.18,19.341,31.17,19.828Z",
    transform: "translate(-201.775 -10825.12)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50290",
    "data-name": "Path 50290",
    d: "M32.039,19a.975.975,0,0,0-.51.146,2.826,2.826,0,0,0-.359,1.161h1.789a.969.969,0,0,0,.06-.327A.981.981,0,0,0,32.039,19Z",
    transform: "translate(-201.775 -10825.6)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50291",
    "data-name": "Path 50291",
    d: "M23.921,15.721s-1.96-.653-3.921,1.96C20.653,15.721,21.96,14.414,23.921,15.721Z",
    transform: "translate(-197.904 -10824.28)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50292",
    "data-name": "Path 50292",
    d: "M32,14.793s2,0,2.308,1.307C33.96,14.139,32.653,14.139,32,14.793Z",
    transform: "translate(-202.063 -10824.006)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50293",
    "data-name": "Path 50293",
    d: "M30.307,24.653,29,25.307,29.653,24Z",
    transform: "translate(-201.023 -10827.332)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50294",
    "data-name": "Path 50294",
    d: "M21.495,45,18.422,39.34,13,43.038Z",
    transform: "translate(-195.478 -10832.648)",
    fill: "#0277bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50295",
    "data-name": "Path 50295",
    d: "M10.518,36,7.723,40.866l6.062,2.975,2.809-5.659Z",
    transform: "translate(-193.65 -10831.491)",
    fill: "#039be5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFred);
export default __webpack_public_path__ + "static/media/fred.9656080051c95c392a6f60eb40882e43.svg";
export { ForwardRef as ReactComponent };